import React from 'react';
import S3FilePicker from '../s3-file-picker/S3FilePicker';

const SquareOnlyFilePicker = function SquareOnlyFilePicker(props) {
    const identifySquareImage = (previewUrl) => {
        let img = new Image();
        img = document.createElement('img');
        img.src = previewUrl;

        return new Promise((resolve) => {
            img.onload = function onLoad() {
                if (img.width !== img.height) {
                    resolve(false);
                } else {
                    resolve(true);
                }
            };
        });
    };

    const identifyImageType = (file) => {
        const imageTypeList = ['image/png', 'image/jpg', 'image/jpeg'];
        if (imageTypeList.includes(file.type)) {
            return true;
        }
        return false;
    };
    return (
        <S3FilePicker
            {...props}
            onhandlefilechanged={identifySquareImage}
            identifyImageType={identifyImageType}
        />
    );
};

export default SquareOnlyFilePicker;
